import { Injectable } from '@angular/core';
import { NativeAudio } from '@ionic-native/native-audio';
import { Loading, Platform } from 'ionic-angular';
import 'rxjs/add/operator/finally';
import { fromPromise } from 'rxjs/observable/fromPromise';

@Injectable()
export class AudioProvider {

    public loader: Loading;

    constructor(
        private platform: Platform,
        private nativeAudio: NativeAudio
    ) {
        if (this.platform.is('cordova')) {
            fromPromise(this.nativeAudio.preloadSimple('bell', 'assets/snd/bell.mp3')).subscribe();
        }
    }

    public ping(debugText: string): void {
        if (this.platform.is('cordova')) {
            this.nativeAudio.stop('bell');
            this.nativeAudio.play('bell');
        } else {
            console.log(debugText);
        }
    }
}



// WEBPACK FOOTER //
// ./src/provider/audio-service.ts